import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comments-toggle"
export default class extends Controller {
  static targets = ["container"]

  toggle(event) {
    if (this.containerTarget.classList.contains("hidden")) {
      this.containerTarget.classList.remove("hidden")
    } else {
      event.preventDefault()
      this.containerTarget.classList.add("hidden")
    }
  }
}
